import { render } from "./SeoSearchTermsCell.vue?vue&type=template&id=2c7301c8&scoped=true"
import script from "./SeoSearchTermsCell.vue?vue&type=script&lang=js"
export * from "./SeoSearchTermsCell.vue?vue&type=script&lang=js"

import "./SeoSearchTermsCell.vue?vue&type=style&index=0&id=2c7301c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7301c8"]])

export default __exports__